import { gql } from '@grandvisionhq/graphql';
import { contactLensLineItemFragment, prescriptionGlassLineItemFragment, solutionLineItemFragment, nonPrescriptionBundleOrderLineItemFragment, regularLineItemFragment } from '../fragments/line-item.js';
import { addressFragment, orderPriceFragment, orderCustomerDetailsFragment, orderInvoiceDetailsFragment, orderPaymentFragment } from '../fragments/order-details.js';
import { orderShippingInfo } from '../fragments/order-shipping-info.js';

const GET_ORDER_BY_TOKEN = gql`
  query GetOrderByToken($token: String!) {
    getOrderByToken(token: $token) {
      loyaltyDetails {
        cardNumber
        points
        cardNumberType
      }
      billingAddress {
        ...AddressFragment
      }
      orderDate
      orderNumber
      paymentMethod
      paymentStatus
      receiptUrl
      hasSubscription
      checkoutId
      shippingAddress {
        ...AddressFragment
      }
      shippingInfo {
        ...OrderShippingInfoFragment
      }
      price {
        ...OrderPriceFragment
      }
      discountCodes {
        code
        name {
          locale
          value
        }
      }
      shipmentStatus
      shipmentTrackingURL
      customerDetails {
        ...OrderCustomerDetailsFragment
      }
      invoiceDetails {
        ...OrderInvoiceDetailsFragment
      }
      serviceStore {
        name
        streetName
        streetNumber
        globalStoreId
      }
      payments {
        ...OrderPaymentFragment
      }
      lineItems {
        __typename
        ... on OrderLineItemRegular {
          ...RegularOrderLineItemFragment
        }
        ... on OrderLineItemContactLens {
          ...ContactLensOrderLineItemFragment
        }
        ... on OrderLineItemPrescriptionGlass {
          ...PrescriptionGlassOrderLineItemFragment
        }
        ... on OrderLineItemSolution {
          ...SolutionOrderLineItemFragment
        }
        ... on OrderLineItemNonPrescriptionBundle {
          ...NonPrescriptionBundleOrderLineItemFragment
        }
      }
    }
  }
  ${contactLensLineItemFragment}
  ${prescriptionGlassLineItemFragment}
  ${solutionLineItemFragment}
  ${nonPrescriptionBundleOrderLineItemFragment}
  ${regularLineItemFragment}
  ${orderShippingInfo}
  ${addressFragment}
  ${orderPriceFragment}
  ${orderCustomerDetailsFragment}
  ${orderInvoiceDetailsFragment}
  ${orderPaymentFragment}
`;

export { GET_ORDER_BY_TOKEN };
//# sourceMappingURL=get-order-by-token.js.map
